const Form011SC = {
    stepName: {
        Notes: "事项",
        SectionA: "个人资料",
        SectionB: "语言能力",
        SectionC: "工作",
        ExchangeProgramme: "交流计划,兴趣及嗜好",
        FurtherInformation: "其他资料",
        Declaration: "声明",
        Consent: "家长 / 监护人同意书",
        Confirmation: "确认",
    },
    title: {
        note: "注意",
        collectionPersonal: "个人资料收集",
        languageProficiency: "(B) 语言能力",
        languageProficiencyNote: "(a) 语言程度",
        employment: "(C) 工作",
        personalParticulars: "(A) 个人资料",
        hkPersonTitle: "居港联络人资料",
        exchangeProgramme: "(D) 交流计划",
        exchangeProgrammeTitle: "你过去曾否带领其他学生交流计划？",
        exchangeProgrammeTableTitle: "若有，请提供有关资料：",
        InterestsAndHobbies: "(E) 兴趣及嗜好",
        InterestsAndHobbiesTableTitle:
            "请填上你的兴趣及嗜好，并附上有关证明文件副本，如有：",
        part2: "第二部分",
        part2title: "推荐 - 由提名学校的校长填写",
        undertakeTitle: `本人明白随团教师及学生代表的选拔是独立处理的。一旦获提名教师入选，不论同样获本人提名参加「计划」的学生(如有)是否获选，本人承诺让该教师于{{undertakeDate}}期内参加交流团。本人将敦促他 / 她出席所有活动及履行一切职务。`,
        furtherInformation: "(F) 其他资料",
        declaration: "(G) 声明",
    },
    label: {
        japanese: "日语",
        english: "英文",
        putonghua: "普通话",
        proficiencyOptions: {
            fluent: "流利",
            canExpress: "略懂",
            cannotSpeak: "不懂",
        },
        remarks: "备注",
        everLearntJapanese: "(b) 你有否进修日语课程？",
        everLearntJapaneseOptions: {
            yes: "有",
            no: "没有",
        },
        learntJapaneseNote: "若有，请提供有关资料，并附上有关证明文件副本：",
        courseName: "课程名称",
        attainedLevel: "获取程度",
        startOrCompletionDate: "开始 / 完结日期",
        schoolName: "学校名称",
        schoolAddress: "学校地址",
        schoolTel: "电话号码",
        schoolFax: "传真号码",
        positionHeld: "职位",
        positionHeldOptions: {
            assistantPrincipal: "副校长",
            seniorTeacher: "主任",
            teacher: "教师",
        },
        presentSchoolDate: "到校任教的日期",
        presentPostDate: "出任现职的日期",
        taughtTitle: "本学年任教高中的科目",
        taughtSubject: "任教科目",
        taughtLevel: "任教级别",
        taughtRemarks: "备注",
        headTitle: "非教学工作 （班主任 / 学会顾问 / 课外活动统筹等）",
        headPosition: "职位",
        natureOfDuty: "职务",
        period: "期间",
        periodFrom: "开始日期",
        periodTo: "完结日期",
        headRemarks: "备注",
        experienceTitle: "其他工作经验 （包括非教学经验及海外的工作经验）",
        instituteName: "机构名称",
        nameRemark: "姓名(请依香港特别行政区护照所示填写)",
        englishName: "英文",
        chineseName: "中文",
        chineseCodeName: "姓名(中文姓名电码)",
        birthDate: "出生日期",
        birthPlace: "出生地点",
        sex: "性别",
        hkIDNo: "香港身份证号码",
        homeAddress: "住址",
        photoAttachment: "请上载照片",
        homeTel: "联络电话号码",
        mobilePhone: "流动电话",
        eMailAddress: "电邮地址",
        faxNo: "传真",
        hkSARPassportNumber: "你是否持有有效的香港特别行政区护照？",
        expiryDate: "届满日期",
        issueDate: "签发日期",
        sexOption: {
            Male: "男",
            Female: "女",
        },
        hkPersonEnName: "姓名(英文)",
        hkPersonCnName: "姓名(中文)",
        hkPersonRelationship: "与获提名人的关系",
        hkPersonAddress: "地址",
        hkPersonHomeTel: "住宅电话",
        hkPersonMobliePhone: "流动电话",
        hkPersonEmail: "电邮地址",
        hkPersonFax: "传真",
        exchangeProgrammePeriod: "期间",
        exchangeProgrammeHostingOrganization: "主办机构",
        exchangeProgrammePlace: "曾经到访的地区 / 国家",
        exchangeProgrammePurpose: "到访目的",
        exchangeProgrammeHostingRole: "职责",
        interestsOrHobbies: "兴趣 / 嗜好",
        achievements: "成绩（相关纪录，如有）",
        gotFirstAidTraining: "(a) 你过去曾否接受急救训练？",
        gotFirstAidTrainingTitle:
            "若有，请提供急救证书的有效日期，并附上有关的证明文件副本。",
        firstAidCertificateExpiryDate: "急救证书的有效日期(日／月／年)",
        trainUpStudentDelegatesArea:
            "(b) 请列出你能训练学生代表的范畴，例如：简单日语、演讲、合唱等",
        supportingApplicationInformation:
            "(c) 请列出其他有助你申请的资料，如曾任日语翻译等",
        attendActivities:
            "(d) 一旦获选，你能否出席安排于星期六、日早上 / 下午及周日午后 / 黄昏举行的活动？",
        attendActivitiesOptions: {
            yes: "可以",
            no: "不可以",
            notSure: "不肯定",
        },
        nomineeName: "获提名人姓名",
        nominationReasons: "本人的提名是基于下列原因",
        principalName: "校长姓名",
        contactTel: "联络电话号码",
        nomineeSign: "获提名人签署",
        presentPost: "现任职位",
        approverEmailAddress: "电邮地址",
        hasPassNoTips: "若有，请提供香港特别行政区护照届满日期",
        passNoExpireDate: "香港特别行政区护照届满日期(日／月／年)"
    },
    options: {
        hasPassNoOp: {
            yes: "有",
            no: "没有",
        }
    },
    errorMsg: {
        englishName: "英文姓名",
        chineseName: "中文姓名",
    },
    note: {
        note1: "(a) 学校须于<b>{{deadline}}</b>递交提名表格及相关文件。学校可透过统一登入系统(https://clo.edb.gov.hk/)递交填妥的提名表格，并上载所需证明文件。",
        note2: "(b) 本表格内的资料将用于处理「计划」的申请。如表格上的空位不敷使用，请<u>另纸</u>填写。",
        note3: `(c) 获提名人须上载照片壹张于本表格上。`,
        note4: "(d) 如未能提供所需资料 / 文件，可能引致申请不获接纳。",
        note5: "(1)	教育局会用本表格所载的个人资料，作以下其中一种或多种用途：",
        note6: "(a)	办理 21 世纪东亚青少年大交流计划的申请；及",
        note7: "(b) 进行有关的研究及编制统计资料，以便规划有关的教育服务。",
        note8: "(2) 你必须在本表格上填写个人资料，如不能提供这些资料，申请的处理工作及结果或会受影响。",
        note9: "(3) 本表格所搜集的个人资料，或会向其他政府部门 / 决策局或接待机构披露，作上文所述用途。",
        note10: "(4) 根据《个人资料（私隐）条例》第 18 和 22 条及附表 1 第 6 原则的规定，你有权要求查阅及改正你的个人资料。要求查阅的权利，包括要求提供本表格所载个人资料的副本，但须缴付费用。",
        note11: `(5) 如欲查询有关本表格所搜集的个人资料，包括要查阅及改正资料事宜，请向教育局延伸支援计划组提出，地址为
        香港湾仔皇后大道东 213 号胡忠大厦 11 楼 1141 室 （电话号码：2892 6663）。`,
        note12: "(a) 本人声明，上述所填报的资料均属真确无讹。",
        note13: "(b) 本人承诺一旦获选，定当：",
        note14: "尽忠职守，并为学生代表树立良好榜样；",
        note15: "出席所有出发前的会议、训练、简介会及彩排活动等；",
        note16: "筹划才艺表演及训练学生代表；",
        note17: "带领学生代表制订有关香港的资料以备向接待机构讲解；",
        note18: "协助代表团的行政工作及出发前的彩排活动；",
        note19: "领导学生代表小组，并履行随团教师的有关职务；",
        note20: "随团照顾学生代表及处理他们的纪律及行为问题；",
        note21: "于外访结束后完成此行的个人评估表；",
        note22: "指导学生代表于外访结束后一个半月内完成交流成果小组报告；",
        note23: "于外访结束后两个月内完成有关此行的报告，并分享如何让学生代表从「计划」中获益的经验；及",
        note24: "应教育局及 / 或赞助机构的邀请或要求，出席相关活动。",
        note25: "填妥的提名表格须连同下列文件一并上载：",
        note26: "(a) 正面半身近照一张；",
        note27: "(b) 其他有助教师提名的证明文件副本；",
        note28: "(c) 通晓 / 学习日语的证明文件副本，如有；及",
        note29: "(d) 急救证书副本，如有。",
    },
};

export default Form011SC;

